export function scrollToTop(options = {}) {
  const { top = 0, behavior = "smooth" } = options;

  window.scrollTo({
    top: top,
    behavior: behavior,
  });
}

export function watchScrollFix(elementSelector, options = {}) {
  const {
    offset = 50, // vzdálenost scrollu kdy aktivujeme fixní pozici
    className = "fixed", // jaká třída se přidá
  } = options;

  const element = document.querySelector(elementSelector);

  if (!element) {
    console.error(`Element ${elementSelector} nebyl nalezen.`);
    return;
  }

  const onScroll = () => {
    if (window.scrollY > offset) {
      element.classList.add(className);
    } else {
      element.classList.remove(className);
    }
  };

  window.addEventListener("scroll", onScroll);
  // hned při načtení stránky taky kontrolujeme
  onScroll();
}
